import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { X, Command } from "lucide-react";

const KeyboardShortcuts = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === '?' && !e.shiftKey) {
        e.preventDefault();
        setIsOpen(!isOpen);
      }
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isOpen]);

  const shortcuts = [
    { key: '?', description: 'Show keyboard shortcuts' },
    { key: 'Esc', description: 'Close modal or dialog' },
    { key: 'Ctrl/Cmd + K', description: 'Focus command input' },
    { key: 'H', description: 'Navigate to Heads-up Display' },
    { key: 'A', description: 'Navigate to Accounts' },
    { key: 'P', description: 'Navigate to Pipeline' },
    { key: 'G', description: 'Navigate to Goals' }
  ];

  if (!isOpen) {
    return (
      <div className="fixed bottom-6 left-6 z-40">
        <button
          onClick={() => setIsOpen(true)}
          className="p-3 bg-[#0f1419] border border-gray-800 rounded-lg text-gray-400 hover:text-white hover:border-[#3dd9c5] transition-all"
          data-testid="shortcuts-trigger"
        >
          <Command className="h-5 w-5" />
        </button>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-6 animate-fade-in">
      <Card className="bg-[#0f1419] border-gray-800 p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-bold text-white flex items-center gap-2">
            <Command className="h-5 w-5 text-[#3dd9c5]" />
            Keyboard Shortcuts
          </h3>
          <button
            onClick={() => setIsOpen(false)}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-3">
          {shortcuts.map((shortcut, idx) => (
            <div key={idx} className="flex items-center justify-between p-3 bg-white/5 rounded-lg">
              <span className="text-sm text-gray-400">{shortcut.description}</span>
              <kbd className="px-3 py-1 bg-gray-800 border border-gray-700 rounded text-xs text-white font-mono">
                {shortcut.key}
              </kbd>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default KeyboardShortcuts;
